import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CheckoutForm from "@razorpaycheckout";

const Razorpay = (props) => {
  return (
    <div id="razorpay-checkout">
      <CheckoutForm {...props} />
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Razorpay);
